export default function downloadFile(doc, url, name) {
  const link = doc.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  doc.body.appendChild(link);
  link.click();
}
